import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\'spinner\' ...attributes>\n  spinner\n</div>\n",{ moduleName: "web-app/components/global/spinner/index.hbs" })